import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const IframeViews = ({ models = [], vrButton = false }: any) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  

  const nextVideo = () => {
    setCurrentIndex((prev) => (prev + 1) % models.length);
  };

  const prevVideo = () => {
    setCurrentIndex((prev) => (prev - 1 + models.length) % models.length);
  };

  const openInVR = (modelUrl: any) => {
    window.open(modelUrl);
  };

  // Convert any YouTube URL (watch / youtu.be / shorts) to embed form and add iframe-friendly params
  const processYouTubeUrl = (url: string) => {
    try {
      if (!(url.includes('youtube.com') || url.includes('youtu.be'))) return url;

      const urlObj = new URL(url);
      let videoId = "";

      if (urlObj.hostname.includes('youtu.be')) {
        videoId = urlObj.pathname.slice(1);
      } else if (urlObj.pathname.startsWith('/watch')) {
        videoId = urlObj.searchParams.get('v') || "";
      } else if (urlObj.pathname.startsWith('/shorts/')) {
        videoId = urlObj.pathname.replace('/shorts/', '');
      } else if (urlObj.pathname.startsWith('/embed/')) {
        videoId = urlObj.pathname.replace('/embed/', '');
      }

      if (!videoId) return url;

      const embed = new URL(`https://www.youtube.com/embed/${videoId}`);
      embed.searchParams.set('rel', '0');
      embed.searchParams.set('modestbranding', '1');
      embed.searchParams.set('controls', '1');
      embed.searchParams.set('iv_load_policy', '3');
      embed.searchParams.set('disablekb', '0');
      embed.searchParams.set('playsinline', '1');
      return embed.toString();
    } catch (error) {
      console.error('Error processing URL:', error);
      return url;
    }
  };

  if (!models?.length) {
    return (
      <div className="w-full aspect-video flex items-center justify-center bg-gray-100 dark:bg-gray-100 rounded-lg">
        <div className="text-center p-4">
          <div className="text-4xl mb-2">🚫</div>
          <p className="text-lg font-medium text-gray-800 dark:text-gray-200">
            No models available
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full relative group">
      <div className="w-full aspect-video xl:w-full xl:h-full relative rounded-lg overflow-hidden">
        <iframe
          key={currentIndex}
          className="w-full h-full"
          src={processYouTubeUrl(models[currentIndex])}
          title={`Property video ${currentIndex + 1}`}
          // geolocation: the Meta Model walkthrough (cross-origin Netlify
          // tour) calls navigator.geolocation.getCurrentPosition() for
          // per-session GPS. Chrome/Safari silently DENY geolocation in a
          // cross-origin iframe unless the parent delegates it here — without
          // it the tour falls back to IP/city-level coords and no prompt shows.
          allow="geolocation; autoplay; fullscreen; picture-in-picture; gyroscope; accelerometer; magnetometer; execution-while-out-of-viewport; execution-while-not-rendered; xr-spatial-tracking;"
          loading="lazy"
          // Additional attributes for better YouTube embedding
          frameBorder="0"
          allowFullScreen
        />
        
        {vrButton && (
          <button
            onClick={() => {
              openInVR(models[currentIndex]);
            }}
            className="absolute top-5 right-10 w-10 h-10 bg-black/30 hover:bg-black/40 text-white rounded-full flex items-center justify-center cursor-pointer z-[1000] border-none transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-rectangle-goggles-icon lucide-rectangle-goggles"
            >
              <path d="M20 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-1.6-.8l-1.6-2.13a1 1 0 0 0-1.6 0L9.6 17.2A2 2 0 0 1 8 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
            </svg>
          </button>
        )}

        {/* Navigation Arrows */}
        {models.length > 1 && (
          <>
            <button
              onClick={prevVideo}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 rounded-full transition-opacity group-hover:opacity-100 opacity-0 md:opacity-100"
              aria-label="Previous video"
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={nextVideo}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 rounded-full transition-opacity group-hover:opacity-100 opacity-0 md:opacity-100"
              aria-label="Next video"
            >
              <ChevronRight size={24} />
            </button>
          </>
        )}
      </div>

      {/* Video Counter */}
      {models.length > 1 && (
        <div className="absolute top-16 right-6 bg-black/50 text-white text-xs px-2 py-1 rounded">
          {currentIndex + 1} / {models.length}
        </div>
      )}
    </div>
  );
};

export default IframeViews;

// import React, { useState, useRef, useEffect } from "react";
// import { ChevronLeft, ChevronRight, Expand, Minimize } from "lucide-react";

// const IframeViews = ({ models = [], vrButton = false }: any) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const iframeRef = useRef<HTMLIFrameElement>(null);
//   const containerRef = useRef<HTMLDivElement>(null);

//   const nextVideo = () => {
//     setCurrentIndex((prev) => (prev + 1) % models.length);
//   };

//   const prevVideo = () => {
//     setCurrentIndex((prev) => (prev - 1 + models.length) % models.length);
//   };

//   const openInVR = (modelUrl: any) => {
//     window.open(modelUrl);
//   };

//   const enterFullscreen = () => {
//     const element = containerRef.current || iframeRef.current;
//     if (element) {
//       if (element.requestFullscreen) {
//         element.requestFullscreen();
//       } else if ((element as any).webkitRequestFullscreen) {
//         (element as any).webkitRequestFullscreen();
//       } else if ((element as any).msRequestFullscreen) {
//         (element as any).msRequestFullscreen();
//       }
//     }
//   };

//   const exitFullscreen = () => {
//     if (document.exitFullscreen) {
//       document.exitFullscreen();
//     } else if ((document as any).webkitExitFullscreen) {
//       (document as any).webkitExitFullscreen();
//     } else if ((document as any).msExitFullscreen) {
//       (document as any).msExitFullscreen();
//     }
//   };

//   const toggleFullscreen = () => {
//     if (isFullscreen) {
//       exitFullscreen();
//     } else {
//       enterFullscreen();
//     }
//   };

//   // Listen for fullscreen changes
//   useEffect(() => {
//     const handleFullscreenChange = () => {
//       setIsFullscreen(
//         document.fullscreenElement !== null ||
//         (document as any).webkitFullscreenElement !== null ||
//         (document as any).msFullscreenElement !== null
//       );
//     };

//     document.addEventListener('fullscreenchange', handleFullscreenChange);
//     document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
//     document.addEventListener('msfullscreenchange', handleFullscreenChange);

//     return () => {
//       document.removeEventListener('fullscreenchange', handleFullscreenChange);
//       document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
//       document.removeEventListener('msfullscreenchange', handleFullscreenChange);
//     };
//   }, []);

//   // Function to process YouTube URLs and add parameters to remove recommendations
//   const processYouTubeUrl = (url: string) => {
//     try {
//       // Check if it's a YouTube URL
//       if (url.includes('youtube.com') || url.includes('youtu.be')) {
//         const urlObj = new URL(url);
        
//         // Comprehensive parameters to clean up YouTube embed
//         urlObj.searchParams.set('rel', '0'); // Hide related videos at the end
//         urlObj.searchParams.set('modestbranding', '1'); // Reduce YouTube branding
//         urlObj.searchParams.set('controls', '1'); // Ensure controls are enabled
//         urlObj.searchParams.set('showinfo', '0'); // Hide video title and uploader
//         urlObj.searchParams.set('iv_load_policy', '3'); // Hide annotations
//         urlObj.searchParams.set('disablekb', '0'); // Enable keyboard controls
//         urlObj.searchParams.set('fs', '0'); // Disable fullscreen button
//         urlObj.searchParams.set('playsinline', '1'); // Play inline on iOS
        
//         return urlObj.toString();
//       }
//       return url;
//     } catch (error) {
//       console.error('Error processing URL:', error);
//       return url;
//     }
//   };

//   if (!models?.length) {
//     return (
//       <div className="w-full aspect-video flex items-center justify-center bg-gray-100 dark:bg-gray-100 rounded-lg">
//         <div className="text-center p-4">
//           <div className="text-4xl mb-2">🚫</div>
//           <p className="text-lg font-medium text-gray-800 dark:text-gray-200">
//             No models available
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div 
//       ref={containerRef}
//       className={`w-full relative group ${isFullscreen ? 'bg-black' : ''}`}
//     >
//       <div className={`${isFullscreen ? 'w-screen h-screen' : 'w-full aspect-video xl:w-full xl:h-full'} relative rounded-lg overflow-hidden`}>
//         <iframe
//           ref={iframeRef}
//           key={currentIndex}
//           className="w-full h-full"
//           src={processYouTubeUrl(models[currentIndex])}
//           title={`Property video ${currentIndex + 1}`}
//           allow="autoplay; fullscreen; picture-in-picture; gyroscope; accelerometer; magnetometer; execution-while-out-of-viewport; execution-while-not-rendered; xr-spatial-tracking;"
//           loading="lazy"
//           // Additional attributes for better YouTube embedding
//           frameBorder="0"
//           allowFullScreen
//         />
        
//         {/* Fullscreen Toggle Button */}
//         <button
//           onClick={toggleFullscreen}
//           className="absolute top-4 right-4 z-50 bg-black/70 hover:bg-black/90 text-white p-2 rounded-md transition-colors flex items-center gap-2 text-sm"
//           title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
//         >
//           {isFullscreen ? <Minimize size={16} /> : <Expand size={16} />}
//           {isFullscreen ? "Exit" : "Fullscreen"}
//         </button>
        
//         {vrButton && (
//           <button
//             onClick={() => {
//               openInVR(models[currentIndex]);
//             }}
//             className="absolute top-5 right-32 w-10 h-10 bg-black/30 hover:bg-black/40 text-white rounded-full flex items-center justify-center cursor-pointer z-[1000] border-none transition-all"
//           >
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="24"
//               height="24"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="lucide lucide-rectangle-goggles-icon lucide-rectangle-goggles"
//             >
//               <path d="M20 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-1.6-.8l-1.6-2.13a1 1 0 0 0-1.6 0L9.6 17.2A2 2 0 0 1 8 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
//             </svg>
//           </button>
//         )}

//         {/* Navigation Arrows */}
//         {models.length > 1 && (
//           <>
//             <button
//               onClick={prevVideo}
//               className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 rounded-full transition-opacity group-hover:opacity-100 opacity-0 md:opacity-100"
//               aria-label="Previous video"
//             >
//               <ChevronLeft size={24} />
//             </button>
//             <button
//               onClick={nextVideo}
//               className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/70 text-white p-2 rounded-full transition-opacity group-hover:opacity-100 opacity-0 md:opacity-100"
//               aria-label="Next video"
//             >
//               <ChevronRight size={24} />
//             </button>
//           </>
//         )}
//       </div>

//       {/* Video Counter */}
//       {models.length > 1 && (
//         <div className="absolute top-16 right-6 bg-black/50 text-white text-xs px-2 py-1 rounded">
//           {currentIndex + 1} / {models.length}
//         </div>
//       )}
//     </div>
//   );
// };

// export default IframeViews;